<div
  class="radio-group"
  [attr.data-orientation]="orientation"
  [attr.data-viewport]="viewport"
  [attr.multiSelectable]="multiSelectable"
  [attr.data-disabled]="disabled"
>
  <ng-content></ng-content>
</div>
